export default "__VITE_ASSET__C26OGq8s__"